<template>
  <el-tabs
    id="feeTab"
    v-model="activeName"
    :before-leave="checkTab"
    @tab-click="handleTabClick"
  >
    <el-tab-pane name="KGIFeePeriodList">
      <span slot="label">期別列表</span>
    </el-tab-pane>
    <el-tab-pane name="KGIFeePaymentList">
      <span slot="label">繳費列表</span>
    </el-tab-pane>
    <el-tab-pane
      v-if="configData.ConfigPayWays"
      name="KGIFeeDeposit"
    >
      <span slot="label">入帳報表</span>
    </el-tab-pane>
    <!-- <el-tab-pane name="FeeWriteoff">
      <span slot="label">銷帳列表</span>
    </el-tab-pane>
    <el-tab-pane name="FeeReconcile">
      <span slot="label">對帳列表</span>
    </el-tab-pane> -->
  </el-tabs>
</template>
<script>
export default {
  props: {
    periodData: Array,
    periodDataNew: Number, // 最新期別
    configData: Object
  },
  data () {
    return {
      activeName: 'KGIFeePeriodList',
      noPeriod: false,
      type: ''
    }
  },
  watch: {
    $route (to, from) {
      this.activeName = to.name
    },
    periodData (list) {
      // eslint-disable-next-line eqeqeq
      if (list.length == 0) { // 列表為零 其他tab設為disable
        this.noPeriod = true
        // eslint-disable-next-line eqeqeq
        if (this.$route.name != 'KGIFeePeriodList') { // 其他頁面則導回期別列表
          if (this.type !== '') {
            this.$router.push({ name: 'KGIFeePeriodList', params: { type: this.type } })
          } else {
            this.$router.push({ name: 'KGIFeePeriodList' })
          }
        }
      } else {
        this.noPeriod = false
      }
    }
  },
  mounted () {
    this.activeName = this.$route.name
    this.type = this.$route.params.type || ''
  },
  methods: {
    checkTab (activeName, oldActiveName) {
      // eslint-disable-next-line eqeqeq
      if (activeName == oldActiveName) {
        return false
        // eslint-disable-next-line eqeqeq
      } else if (activeName != 'KGIFeePeriodList' && this.noPeriod) { // 期別列表為空 限制只能前往期別列表
        if (this.type !== '') {
          this.$router.push({ name: 'KGIFeePeriodList', params: { type: this.type } })
        } else {
          this.$router.push({ name: 'KGIFeePeriodList' })
        }
        this.$message({
          message: '請先新增期別',
          type: 'warning'
        })
        return false
        // eslint-disable-next-line eqeqeq
      } else if (activeName == 'KGIFeePaymentList') { // 到繳費列表未獲得期別id 則重新取得並賦值
        if (!this.$route.params.id) {
          if (this.type !== '') {
            this.$router.push({ name: activeName, params: { type: this.type, id: this.periodDataNew } })
          } else {
            this.$router.push({ name: activeName, params: { id: this.periodDataNew } })
          }
        }
      } else {
        if (this.type !== '') {
          this.$router.push({ name: activeName, params: { type: this.type } })
        } else {
          this.$router.push({ name: activeName })
        }
      }
    },
    handleTabClick (tab, event) {
      switch (tab.paneName) {
        case 'KGIFeePeriodList':
          this.$emit('updatePeriod')
          break
        default:
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#feeTab
  ::v-deep .el-tabs
    +basicTabs
    &__header
      margin: 0 0 0
    &__item
      min-width: 130px
      height: 42px
      span
        width: 100%
        display: inline-block
</style>
